import React from 'react'
import PickerToolbar from '@material-ui/pickers/_shared/PickerToolbar'
import ToolbarButton from '@material-ui/pickers/_shared/ToolbarButton'
import moment from 'moment'
import 'moment/locale/ar-sa'
import { useStyles } from './Styles'
import { LanguageConsumer } from '../../context/LanguageContext'

const CustomToolbarMonth = function(props) {

  const {
    date,
    isLandscape,
    openView,
    setOpenView,
    title
  } = props

  const handleChangeViewClick = (view) => (e) => {
    setOpenView(view)
  }
  const classes = useStyles()
  return (
    <LanguageConsumer>
      {({ locale }) => (
        <PickerToolbar className={classes.toolbar} title={title} isLandscape={isLandscape}>
          <ToolbarButton
            onClick={handleChangeViewClick('year')}
            variant="h6"
            label={moment(date).locale(locale === 'ar' ? 'ar-sa' : 'en-us').format('YYYY')}
            selected={openView === 'year'}
          />
          <ToolbarButton
            onClick={handleChangeViewClick('month')}
            variant="h4"
            selected={openView === 'month'}
            label={moment(date).locale(locale === 'ar' ? 'ar-sa' : 'en-us').format('MMMM')}
          />
        </PickerToolbar>
      )}
    </LanguageConsumer>
  )

}

export default CustomToolbarMonth